import React, { useState, useEffect } from 'react';
import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Button,
  useToast,
  Text,
  Badge,
  Stack,
} from '@chakra-ui/react';
import api from '../../utils/api';

const PendingAgents = () => {
  const [pendingAgents, setPendingAgents] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();

  const fetchPendingAgents = async () => {
    try {
      const response = await api.get('/api/auth/pending-agents');
      setPendingAgents(response.data.data);
    } catch (error) {
      console.error('Error fetching pending agents');
      toast({
        title: 'Error',
        description: 'Failed to fetch pending agents',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    fetchPendingAgents();
  }, []);

  const handleApproval = async (agentId, isApproved) => {
    setIsLoading(true);
    try {
      const token = localStorage.getItem('token');
      await api.put(
        `/api/auth/approve-agent/${agentId}`, 
        { isApproved },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      toast({
        title: isApproved ? 'Agent Approved' : 'Agent Rejected',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      fetchPendingAgents(); // Refresh the list
    } catch (error) {
      toast({
        title: 'Error',
        description: error.response?.data?.message || 'Failed to update agent status',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box p={4}>
      <Text fontSize="2xl" mb={4}>Pending Agent Approvals</Text>
      {pendingAgents.length === 0 ? (
        <Text>No pending agents to approve</Text>
      ) : (
        <Table variant="simple">
          <Thead>
            <Tr>
              <Th>Name</Th>
              <Th>Email</Th>
              <Th>Role</Th>
              <Th>Phone</Th>
              <Th>Address</Th>
              <Th>Actions</Th>
            </Tr>
          </Thead>
          <Tbody>
            {pendingAgents.map((agent) => (
              <Tr key={agent._id}>
                <Td>{agent.name}</Td>
                <Td>{agent.email}</Td>
                <Td>
                  <Badge colorScheme={agent.role === 'agent' ? 'green' : 'blue'}>
                    {agent.role}
                  </Badge>
                </Td>
                <Td>{agent.phone}</Td>
                <Td>{agent.address}</Td>
                <Td>
                  <Stack direction="row" spacing={2}>
                    <Button
                      colorScheme="green"
                      size="sm"
                      isLoading={isLoading}
                      onClick={() => handleApproval(agent._id, true)}
                    >
                      Approve
                    </Button>
                    <Button
                      colorScheme="red"
                      size="sm"
                      isLoading={isLoading}
                      onClick={() => handleApproval(agent._id, false)}
                    >
                      Reject
                    </Button>
                  </Stack>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      )}
    </Box>
  );
};

export default PendingAgents; 